<script setup lang="ts">
import { expandLinks, items } from '..';

defineEmits<{ closeBurger: [] }>();

const itemsExpanded = computed(() => expandLinks(items));

const linkReservation = 'Rezervace';
</script>

<template>
  <TransitionGroup
    appear
    tag="div"
    name="stagger"
    class="pt-r8 sm:pt-r16 flex h-full max-h-[calc(100%-var(--navbar-height))] flex-col overflow-auto"
  >
    <template v-for="(item, i) in itemsExpanded" :key="item.label">
      <AppLink
        type="custom"
        :to="item.link"
        :opts="{}"
        :style="{ '--stagger-index': i }"
        class="text-client-black py-r2 sm:py-r6 text-2xl font-bold uppercase sm:text-4xl"
        @click="$emit('closeBurger')"
      >
        {{ item.label }}
      </AppLink>
      <AppLink
        v-if="i === itemsExpanded.length - 1"
        type="custom"
        to="https://okgym.clubspire.cz/"
        :opts="{ link: { external: true } }"
        :style="{ '--stagger-index': itemsExpanded.length }"
        class="text-client-black py-r2 sm:py-r6 text-2xl font-bold uppercase sm:text-4xl"
        @click="$emit('closeBurger')"
      >
        {{ linkReservation }}
      </AppLink>
    </template>
  </TransitionGroup>
</template>

<style scoped lang="css">
.stagger-enter-active {
  transition: all 1s cubic-bezier(0.23, 1, 0.32, 1);
  transition-delay: calc(var(--stagger-index) * 75ms);
}

.stagger-enter-from {
  opacity: 0;
  transform: translateY(2.5rem);
}

.stagger-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>
